export enum PositionSideBarSearch {
  LEFT = 'left',
  RIGHT = 'right',
}
